// src/components/BookingStepper.js
import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

import BookingPage from '../pages/BookingPage';
import PaymentPage from '../pages/PaymentPage';
import ConfirmationPage from '../pages/ConfirmationPage';

const steps = ['Booking', 'Payment', 'Confirmation'];

export default function BookingStepper() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initial = parseInt(params.get('step'), 10);
  const [activeStep, setActiveStep] = useState(!isNaN(initial) ? initial : 0);

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const handleNext = () => setActiveStep((p) => Math.min(p + 1, steps.length - 1));
  const handleBack = () => setActiveStep((p) => Math.max(p - 1, 0));

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <BookingPage onNext={handleNext} />;
      case 1:
        return <PaymentPage onBack={handleBack} onNext={handleNext} />;
      case 2:
        return <ConfirmationPage />;
      default:
        return <Typography>Unknown step</Typography>;
    }
  };

  return (
    <Box sx={{ width: '100%', px: 0, mt: { xs: 8, sm: 14 }, overflowX: 'clip' }}>
      <Box sx={{ mx: 'auto', maxWidth: 680, px: { xs: 2, sm: 3 } }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel={!isXs}
          sx={{
            width: '100%',
            overflow: 'hidden',
            '& .MuiStep-root': { flex: 1, minWidth: 0 },
            '& .MuiStepLabel-label': { display: { xs: 'none', sm: 'block' } },
            '& .MuiStepIcon-root': { fontSize: { xs: 18, sm: 20 } },
            '& .MuiStepConnector-line': { minWidth: 0 },
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Box sx={{ mx: 'auto', maxWidth: 680, px: { xs: 2, sm: 3 }, mt: 5 }}>
        {getStepContent(activeStep)}
      </Box>
    </Box>
  );
}